export default __webpack_public_path__ + "static/media/nav_detail_image_1.a55521ac.png";